<template>
  <div class="modal fade" id="age-limit-to-crypto">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">みんなのコイン</h4>
        </div>
        <div class="modal-body">
          <p id="note" v-html="ageLimitMsg"></p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ModalPlugin from "@/common/plugins/ModalPlugin.js";

export default {
    name: "CryptoAgeLimitModal",
    data() {
        return {
            ageLimitMsg: ""
        }
    },
    mounted() {
      ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.SHOW_AGE_LIMIT_MSG, (msg) => {
            this.updateAgeLimitMsg(msg);
            this.show();
        });
    },
    methods: {
        updateAgeLimitMsg(msg) {
            this.ageLimitMsg = msg;
        },
        show() {
            $("#age-limit-to-crypto").modal("show");
        },
        hide() {
            $("#age-limit-to-crypto").modal("hide");
        }
    }
}

</script>

<style scoped>
.modal-dialog{
  max-width: 600px !important;
}
</style>
